import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { AccountContext, useAsync } from '../../../hooks';
import Username from '../../user/Username';

export default function CommandPanel() {
    let { user } = useContext(AccountContext);
    let [users, setUsers] = useState([]);

    useAsync(async () => {
        let { data } = await axios.post('/api/duel-pool', { user });
        data.reverse();
        setUsers(data);
    }, [])

    return users.length>0 ? <div className="ContestsPanel Side Panel">
        <h3 className="mb">Duel pool</h3>
        {users.map((username,i) => <NavLink
            key = {username}
            className = "noUnderline"
            to = {'/user/'+username.toLowerCase()}
        ><div className={"chainLink"}>
            <div className="count">{(i+1) < 10 ? '0' + (i+1) : (i+1)}</div>
            <div className="theme">
                <h4><Username username={username} unClickable/></h4>
            </div>
        </div></NavLink>)}
    </div> : null
}